// extracted by mini-css-extract-plugin
export default {"contain":"Error_contain__BDSly","h3":"Error_h3__wLcde","p":"Error_p__SA1bA","okbtn":"Error_okbtn__wusHv"};